var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtecaoPoupanca(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.168 17.6499C13.168 18.2945 14.66 18.8166 16.5013 18.8166C18.3426 18.8166 19.8346 18.2945 19.8346 17.6499",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 14.8333C13.166 15.7541 14.8851 16.2727 16.7265 16.2727C18.5678 16.2727 19.8327 15.7541 19.8327 14.8333",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 13.1667C14.6586 13.1667 13.1647 13.9126 13.166 14.8334",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 14.8333V20.1666C13.166 20.9033 14.658 21.4999 16.4993 21.4999",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.1667C18.3407 13.1667 19.8347 13.9126 19.8333 14.8334",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 14.8333V20.1666C19.8333 20.9033 18.3413 21.4999 16.5 21.4999",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.75C7 16.3358 6.66421 16 6.25 16C5.83579 16 5.5 16.3358 5.5 16.75H6.25H7ZM11 16.75V16H9.5V16.75H10.25H11ZM8.25 18.75V18C7.55964 18 7 17.4404 7 16.75H6.25H5.5C5.5 18.2688 6.73122 19.5 8.25 19.5V18.75ZM10.25 16.75H9.5C9.5 17.4404 8.94036 18 8.25 18V18.75V19.5C9.76878 19.5 11 18.2688 11 16.75H10.25Z",
    fill: "#FF5800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.75C14.2292 1.75 17.7656 5.14453 18.2041 9.5752C18.2081 9.616 18.1963 9.65132 18.1641 9.68457C18.1288 9.72087 18.0716 9.75 18 9.75H2C1.92841 9.75 1.87124 9.72087 1.83594 9.68457C1.80369 9.65132 1.79186 9.616 1.7959 9.5752C2.23443 5.14453 5.77078 1.75 10 1.75Z",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15L10.25 10",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15V16.5",
    stroke: "#FF5800",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtecaoPoupanca);
export default __webpack_public_path__ + "static/media/protecao-poupanca.1fc63d4186446f891e4ae89ea879bf7f.svg";
export { ForwardRef as ReactComponent };